import { createStandardAction } from "typesafe-actions";
import { User } from "../../models/User";

export const updateUser = createStandardAction("UPDATE_USER")<User>();
